import React, { useCallback, useEffect, useRef } from "react"
import { useState } from "react"
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import PatientSearch from "./PatientSearch"
import { connect, useSelector } from "react-redux";
import { TabActionPatient } from "../../actions/PatientActions";
import PatientTab from './PateintTab'
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import ModalHeader from "../Setup/Shared/ModalHeader";
import TextEditor from "../../shared-components/TextEditor";
import DatePicker from "../General/DatePicker";
import handleCopyText from "../shared/CopyData";
import { isChildWindow } from "../../utils/Constants";
import PatientAttendance from "./PatientAttendance";
import { GeneralDropDowns } from "../../actions/GeneralPatientActions";
import DiscardChangesPopup from "../shared/DiscardChanges/DiscardChangesPopup";
import { debounce } from "lodash";
import { FindFirstChild } from "../../utils/FindMenuOption";

const Patient = (props) => {
    let PatientData = useSelector(state => state.Open_Patient_Tab);
    const [recordsNum, setRecordsNum] = useState(false);

    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const IsAdultDayCare = DropDowns.IsAdultDayCare;
    const isViewAllowedPatientAttendence = FindFirstChild('Patient', 'Patient Attendance')?.ISView;
    let dispatch = useDispatch();
    const [tabList, setTabsList] = useState([])

    const [activeTab, setActiveTab] = useState(0)
    useEffect(() => {
        if (props.OpenDynamicTab && props.OpenDynamicTab.length > 0) {
            AddDynamicTabData(props)
        }
        else {
            let objj = {
                active: true,
                key: 2,
                name: "Patient",
                data: {
                    name: "All Patient",
                    id: 0,
                    time: new Date(),
                    // component: <PatientSearch setRecordsNum={setRecordsNum} />,
                },
            }
            props.TabActionPatient(objj);

            if (IsAdultDayCare === 'true' && isViewAllowedPatientAttendence) {
                let objj1 = {
                    active: false,
                    key: 2,
                    name: "Patient",
                    data: {
                        name: "Patient Attendance",
                        id: 1,
                        time: new Date(),
                        // component: <PatientAttendance setRecordsNum={setRecordsNum} />,
                    },
                }
                props.TabActionPatient(objj1);
                props.TabActionPatient(objj);
            }
            // setTabsList(
            //     [
            //         {
            //             active: true,
            //             key: 2,
            //             name: "Patient",
            //             data: {
            //                 name: "All Patient",
            //                 id: 0,
            //                 // component: <PatientSearch setRecordsNum={setRecordsNum} />,
            //             },
            //         },
            //         ...(IsAdultDayCare === 'true' && isViewAllowedPatientAttendence ? [{
            //             active: true,
            //             key: 2,
            //             name: "Patient",
            //             data: {
            //                 name: "Patient Attendance",
            //                 id: 1,
            //                 // component: <PatientAttendance setRecordsNum={setRecordsNum} />,
            //             },
            //         }] : []),
            //     ])
            setActiveTab(0)


        }

    }, [props.OpenDynamicTab, IsAdultDayCare])

    const AddDynamicTabData = (data) => {

        let tabDataFromRedux = data.OpenDynamicTab.length > 0 ? data.OpenDynamicTab : [];
        const DataFromRedux = tabDataFromRedux.filter((ele) => { return ele.key === 2; });   // fetch only whose id is 2
        const activeElements = DataFromRedux.filter((row) => row.active === true); // get active 
        let LengthCheck = IsAdultDayCare === "true" ? tabList.length === 2 : tabList.length === 1;
        if (activeElements.length > 0 && LengthCheck) {
            ///////////////////////////
            // let tabsData = [...tabList]
            // tabsData = tabsData.concat(...DataFromRedux)
            //////////////////////////
            const mapKey = (tab) => `${tab.key}_${tab.data.id}`;
            const tabsMap = new Map(tabList.map(tab => [mapKey(tab), tab]));
            for (const newTab of DataFromRedux) {
                tabsMap.set(mapKey(newTab), newTab); // Replaces if exists, adds if not
            }
            const tabsData = Array.from(tabsMap.values());
            /////////////////////////////
            setTabsList(tabsData)

            setActiveTab(activeElements[0].data.id)
        } else {
            let firstPatientTab = tabList.filter((el) => el?.data?.id === 0 || el?.data?.id === 1);

            let tabs = [...firstPatientTab]
            // check if all pat exist in redux 

            const isExist = tabDataFromRedux.some((ele) => { return ele.key === 2 && (ele?.data?.id === 0 || ele?.data?.id === 1); });
            if (isExist) {
                setTabsList(DataFromRedux)
            } else {
                tabs = tabs.concat(...DataFromRedux)
                setTabsList(tabs)
            }
            setActiveTab(activeElements[0].data.id)
        }
    }
    // active tab 
    const handleActiveTab = (item) => {
        if (isChildWindow) return;

        const { data } = { ...item }
        if (activeTab !== data?.id) {
            setActiveTab(data?.id)
        }

        // if (item?.data?.id !== 0 && item?.data?.id !== 1) {
        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: data?.id,
                name: data?.name,
                time: new Date(),
                component: data?.component,
            },
        };
        props.TabActionPatient(obj);
        // }

    }

    let DiscardIndicator = useSelector(state => state.GeneralDropDownsReducer.DiscardIndicator)
    let GenDD = useSelector(state => state.GeneralDropDownsReducer)
    // handle to close tab
    const [pendingTabClose, setPendingTabClose] = useState(null);

    // console.log(GenDD?.DisCardActiveIds.Patient);

    const handleCloseTab = async (id) => {
        let DD = GenDD
        DD?.DisCardActiveIds.Patient.map((item) => {
            if (item.PatientID + "" === id + "") {
                if (item.isDemographicsOpened || item.isInsuranceOpened) {
                    dispatch(GeneralDropDowns({
                        ...GenDD, DiscardIndicator: true,
                    }))

                    // dispatch(GeneralDropDowns({
                    //     ...GenDD, DiscardIndicator: true, DisCardActiveIds: {
                    //         ...GenDD?.DisCardActiveIds,
                    //         Patient: {
                    //             ...GenDD?.DisCardActiveIds.Patient,
                    //             PatientID: id,
                    //         }
                    //     }
                    // }))
                    setPendingTabClose(id); // Store pending tab close ID
                } else {
                    let index = tabList.findIndex((el) => el?.data?.id === id);
                    tabList.splice(index, 1);
                    let activTab =
                        tabList.length > 0
                            ? tabList[tabList.length - 1]?.data?.id
                            : 0;
                    setTabsList(tabList)

                    setActiveTab(activTab)

                    props.TabActionPatient({}, id);

                    const updatedPatients = GenDD?.DisCardActiveIds.Patient.filter(
                        item => item.PatientID + "" !== id + ""
                    );
                    dispatch(GeneralDropDowns({
                        ...GenDD,
                        DisCardActiveIds: {
                            ...GenDD?.DisCardActiveIds,
                            Patient: updatedPatients,
                        }
                    }));
                }
            }
        })
    };
    useEffect(() => {
        if (DiscardIndicator === false && pendingTabClose !== null) {
            let DD = GenDD
            DD?.DisCardActiveIds.Patient.map((item) => {
                if (item.PatientID + "" === pendingTabClose + "") {
                    if (item.isDemographicsUpdated || item.isInsuranceUpdated) {
                        // dispatch(GeneralDropDowns({
                        //     ...GenDD, DiscardIndicator: true,
                        // }))
                        setIsDiscardChanges(true)
                    } else {
                        handleClosePatient()
                    }
                }
            })
        }
    }, [DiscardIndicator, pendingTabClose]);


    const [isDiscardChanges, setIsDiscardChanges] = useState(false)

    const onProceedWithDiscardChanges = () => {
        handleClosePatient()
        // dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
        setIsDiscardChanges(false)
    }

    const handleClosePatient = () => {
        let index = tabList.findIndex((el) => el.data.id === pendingTabClose);
        tabList.splice(index, 1);
        let activTab =
            tabList.length > 0
                ? tabList[tabList.length - 1].data.id
                : 0;

        setTabsList(tabList)

        setActiveTab(activTab)
        props.TabActionPatient({}, pendingTabClose);

        // will be remove from the list => first find id of the patient from list  DisCardActiveIds.patient then remove the pateint 
        const updatedPatients = GenDD?.DisCardActiveIds.Patient.filter(
            item => item.PatientID + "" !== pendingTabClose + ""
        );
        dispatch(GeneralDropDowns({
            ...GenDD,
            DiscardIndicator: false,
            DisCardActiveIds: {
                ...GenDD?.DisCardActiveIds,
                Patient: updatedPatients,
            }
        }));
        setPendingTabClose(null); // Reset pending tab
    }
    const handleCancelDiscard = () => {
        setIsDiscardChanges(false)
        dispatch(GeneralDropDowns({ ...GenDD, DiscardIndicator: null }))
    }

    let DiscardPopup
    if (isDiscardChanges) {
        DiscardPopup = <DiscardChangesPopup isDiscardChanges={isDiscardChanges} handleCancelDiscard={handleCancelDiscard} onProceedWithDiscardChanges={onProceedWithDiscardChanges} />
    }


    let SideBarActiveKey = useSelector(state => state.SidebarActiveTab);

    const comboKeys = useRef([]); // ✅ Holds current key sequence
    const isInputFocused = () => {
        const activeElement = document.activeElement;
        return (
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.tagName === 'SELECT' ||
            activeElement.isContentEditable
        );
    };
    const executeCombo = useCallback(
        debounce(() => {
            if (isInputFocused()) {
                comboKeys.current = []; // Clear combo if input is focused
                return;
            }
            const sequence = comboKeys.current.join('+');
            if (SideBarActiveKey === 2) {
                if (sequence === 'escape') {
                    let activePatinet = PatientData.filter((el) => el.active === true)[0]
                    handleCloseTab(activePatinet?.data?.id)
                }
            } else {
            }
            comboKeys.current = []; // ✅ Clear combo after handling
        }, 500), [SideBarActiveKey, activeTab])

    useEffect(() => {
        const handleKeyDown = (event) => {
            // if (!event.altKey) return;
            if (isInputFocused()) {
                return;
            }
            const key = event.key.toLowerCase();

            // if (['n', 'r', 'p', 'escape'].includes(key)) {
            //     event.preventDefault();
            //     event.stopPropagation();
            // }
            comboKeys.current.push(key);
            executeCombo(); // Debounced logic
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            executeCombo.cancel(); // ✅ Clean up debounce
        };
    }, [executeCombo]);
    return (
        <>
            {DiscardPopup}
            <div className='app-tabs fix-tabs'>
                <Nav className="rb-tabs bg-light-blue nav-tabs pt-1 hk-cross-tabs ar_tabs-changes">
                    {tabList && tabList.map((item) => {
                        return (
                            <React.Fragment key={item?.data?.id}>
                                <NavItem >
                                    <NavLink
                                        href="#"
                                        className={activeTab === item?.data?.id ? "active" : ""}
                                        onClick={() => {
                                            handleActiveTab(item);
                                        }}
                                    >
                                        {item?.data?.name}

                                    </NavLink>
                                    {(item.data?.id === 0 || item.data?.id === 1) ? null :
                                        !isChildWindow && <span onClick={() => handleCloseTab(item?.data?.id)} class="icon-cross-cricle fs-15"><span class="path1"></span><span class="path2"></span></span>
                                    }
                                    {item?.data?.id === 0 && recordsNum !== 0 ? <div className="counter heading">{recordsNum}</div> : null}
                                </NavItem>
                            </React.Fragment>
                        )
                    })}
                </Nav>
                <TabContent activeTab={activeTab}>
                    {tabList &&
                        tabList.filter((el) => (el?.data?.id === 0 || el?.data?.id === 1)).map((item) => {
                            return (
                                <React.Fragment key={item?.data?.id}>
                                    <TabPane tabId={item?.data?.id}>
                                        {item?.data?.id === 0 ? <PatientSearch setRecordsNum={setRecordsNum} /> : item?.data?.id === 1 ? <PatientAttendance setRecordsNum={setRecordsNum} /> : null}
                                    </TabPane>
                                </React.Fragment>
                            )
                        })}
                    {tabList &&
                        tabList.filter((el) => (el?.data?.id !== 0 && el?.data?.id !== 1)).map((item) => {
                            return (
                                <React.Fragment key={item?.data?.id}>
                                    <TabPane tabId={item?.data?.id}>
                                        <PatientTab Active={activeTab} />
                                    </TabPane>
                                </React.Fragment>
                            )
                        })}

                </TabContent>
            </div>

            {/* Alert Message Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal ar_palceholder">
                <Modal.Body>
                    <ModalHeader HeaderName={() => { }} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">Alert Message</p>

                                    <div className="opened-block__lite">
                                        <TextEditor value={"Hi John.............."} />

                                        <div className="row opened-block__lite__form">
                                            <div className="col-5 mt-2">
                                                <DatePicker
                                                    label='Start Date'
                                                    value={""}
                                                    handleCalendarChangefunc={() => { }}
                                                />
                                            </div>
                                            <div className="col-5 mt-2">
                                                <DatePicker
                                                    label='End Date'
                                                    value={""}
                                                    handleCalendarChangefunc={() => { }}
                                                />
                                            </div>
                                            <div className="col-6 mt-2">
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="global" />
                                                    <label className="form-check-label" for="global">Global</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="appointement" />
                                                    <label className="form-check-label" for="appointement">Show Alert in Appointment Section</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="patient" />
                                                    <label className="form-check-label" for="patient">Show Alert in Patient Section</label>
                                                </div>
                                            </div>
                                            <div className="col-6 mt-2">
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="appointement" />
                                                    <label className="form-check-label" for="appointement">Show Alert in Claim Section</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="patient" />
                                                    <label className="form-check-label" for="patient">Show Alert in Payment Section</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                    <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Save</button>
                                    <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Alerts Small Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal hk-alerts_box hk-alerts_leftBox ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Patient ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal hk-alerts_box ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Patient ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal hk-alert__modal hk-alerts_box hk-modal-v1 hk-alerts_rightBox ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Patient ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Patient: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

function mapStateToProps(state) {
    return {
        OpenDynamicTab: state.Open_Patient_Tab ? state.Open_Patient_Tab : [],
    };
}

const action = {
    TabActionPatient,
};


export default connect(mapStateToProps, action)(Patient)

